import { CreditReport } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

type ConsumerStatementProps = {
  consumer_statements?: CreditReport["consumer_statements"];
  isNoHit: boolean;
};

export const ConsumerStatement = ({
  consumer_statements,
  isNoHit
}: ConsumerStatementProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Consumer statement">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Consumer statement">
      {consumer_statements?.length ? (
        <>
          {consumer_statements.map((consumer_statement, index) => (
            <div key={`credit-report-consumer-statement-${index}`}>
              <p className="text-sm font-bold text-content-1000">
                Consumer Statement {index + 1}
              </p>
              <div className="flex flex-wrap  pt-4">
                <div className="flex flex-col gap-3">
                  <Row title="Statement" value={consumer_statement.statement} />
                  <Row
                    title="Date Reported"
                    value={consumer_statement.date_reported}
                  />
                  <Row
                    title="Date purged"
                    value={consumer_statement.date_purged}
                  />
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="text-base font-medium">No data available</div>
      )}
    </Section>
  );
};
